$(document).ready(function () {
    $('.cta-btn').on('click', function (event) {
    if (this.hash !== '') {
      event.preventDefault();

      var hash = this.hash;

      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });
  const topScroll = $('header').height();
  const cuponLanding = $('#cupon-landing');
  if (cuponLanding.length) {
    const bottomScroll = cuponLanding.offset().top - cuponLanding.height();
    $(window).on('scroll', function () {
      if (
        $(this).scrollTop() > topScroll &&
        $(this).scrollTop() < bottomScroll
      ) {
        $('.cta-fijo').show(300);
      } else {
        $('.cta-fijo').hide(300);
      }
    });
  }
});

jQuery(function () {
  $('.slider-cursos').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    cssEase: 'ease-in-out',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true
        }
      }
    ]
  });
});

function goTo(id) {
  $('html, body').animate({scrollTop: $("#"+id).offset().top},'slow');
}


function chkPais(idpais, idForm = "#frmCupon ") {
  idForm = !empty(idForm) ? idForm + ' ' : '#frmCupon ';
  configurarCamposCupon(idpais, idForm);
  
  if(!$(idForm + "#prefTelf").hasClass("no-change")) {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCodigosPaises&idpais=" + idpais,
      success: function (data) {
        data = JSON.parse(data);

        configurarTelefono(idpais, data.sCodigoTelefonico, data.sTelefPattern, idForm);

        $(idForm + ".telefono").unbind("mouseover mouseout").off();

        if (!empty(data.sTooltip)) {
          var tooltip = $(".text-tooltip");
          tooltip.html(data.sTooltip);
          var alturaTooltip = tooltip.innerHeight();
          tooltip.css({
            top: -alturaTooltip - 15,
          });
          $(idForm + ".telefono").mouseover(function (e) {
            $(".text-tooltip").fadeIn(500);
          });
          $(idForm + ".telefono").mouseout(function () {
            tooltip.fadeOut(500);
          });
        }
      },
    });
  }
}

function chkPrefijo(sCodigoTelefonico, sCodPais, sTelefPattern, sTooltip, idForm = '#frmCupon ') {

  if(!$(idForm + "#prefTelf").hasClass("no-change"))
    $(idForm + "#prefTelf").addClass("no-change")

  configurarTelefono(sCodPais, sCodigoTelefonico, sTelefPattern, idForm);

  $(idForm + '.telefono').unbind('mouseover mouseout').off();

  if (!empty(sTooltip)) {
    var tooltip = $('.text-tooltip');
    tooltip.html(sTooltip);
    var alturaTooltip = tooltip.innerHeight();
    tooltip.css({
      top: -alturaTooltip - 15,
    });
    $(idForm + '.telefono').mouseover(function (e) {
      $('.text-tooltip').fadeIn(500);
    });
    $(idForm + '.telefono').mouseout(function () {
      tooltip.fadeOut(500);
    });
  }
}

function empty(mixed_var) {
  //  discuss at: http://phpjs.org/functions/empty/
  // original by: Philippe Baumann
  //    input by: Onno Marsman
  //    input by: LH
  //    input by: Stoyan Kyosev (http://www.svest.org/)
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Onno Marsman
  // improved by: Francesco
  // improved by: Marc Jansen
  // improved by: Rafal Kukawski
  //   example 1: empty(null);
  //   returns 1: true
  //   example 2: empty(undefined);
  //   returns 2: true
  //   example 3: empty([]);
  //   returns 3: true
  //   example 4: empty({});
  //   returns 4: true
  //   example 5: empty({'aFunc' : function () { alert('humpty'); } });
  //   returns 5: false

  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, "", "0"];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === "object") {
    for (key in mixed_var) {
      // TODO: should we check for own properties only?
      //if (mixed_var.hasOwnProperty(key)) {
      return false;
      //}
    }
    return true;
  }

  return false;
}

function configurarCamposCupon(idpais, idForm) {
  idForm = !empty(idForm) ? idForm + ' ' : '#frmCupon ';
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoCodigoPostal = 'form_cupon_cupon_codigopostal';
  /***/ idCampoProvincia = 'provinciaid';
  /***/
  /* ********************************************* */

  if (idpais == 90 || idpais == 'ES') {

    getComboMD("provincia", "true", idpais, '', idForm);

    $(idForm + '#' + idCampoCodigoPostal).attr('required', true);
    $(idForm + '#' + idCampoCodigoPostal).show();
    $(idForm + '.' + idCampoCodigoPostal).show();
    $(idForm + '#' + idCampoProvincia).attr('required', true);
    $(idForm + '#' + idCampoProvincia).addClass('form-field');
    $(idForm + '#cont-provincia').show();
    $(idForm + '.' + idCampoProvincia).show();
    $(idForm + '#sProvincia').html("Provincia<span style='color:red;'>*</span>");
    $(idForm + '.div-campo-unido').addClass("campo-unido");

    $(idForm + '#requeridos_codigo_postal').val('codigopostal'); //Para que sea obligatorio el campo código postal $('#provinciaid').attr('required',true);
    $(idForm + '#requeridos_provincia').val('provinciaid'); //Para que sea obligatorio el campo provincia
  } else if (idpais == 249 || idpais == 61) {
    getComboMD("provincia", "true", idpais, '', idForm);

    $(idForm + '#' + idCampoProvincia).attr("required", true);
    $(idForm + '#cont-provincia').show();
    $(idForm + '.' + idCampoProvincia).show();
    $(idForm + '#sProvincia').html("Estado<span style='color:red;'>*</span>");    
    $(idForm + '#' + idCampoProvincia).addClass('form-field');
    $(idForm + '.div-campo-unido').removeClass("campo-unido");
    $(idForm + '#' + idCampoCodigoPostal).attr("required", false);
    $(idForm + '#' + idCampoCodigoPostal).val(""); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#' + idCampoCodigoPostal).hide();
    $(idForm + '.' + idCampoCodigoPostal).hide();

    $(idForm + '#requeridos_codigo_postal').val(''); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#requeridos_provincia').val('provinciaid'); //Para que NO sea obligatorio el campo provincia
  } else {

    $(idForm + '#' + idCampoProvincia).attr('required', false);
    
    $(idForm + '#cont-provincia').hide();
    $(idForm + '.' + idCampoProvincia).hide();
    $(idForm + '#' + idCampoProvincia).val('');
    $(idForm + '#' + idCampoCodigoPostal).attr('required', false);
    $(idForm + '#' + idCampoCodigoPostal).val(''); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#' + idCampoCodigoPostal).hide();
    $(idForm + '.' + idCampoCodigoPostal).hide();

    $(idForm + '#requeridos_codigo_postal').val(''); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#requeridos_provincia').val(''); //Para que NO sea obligatorio el campo provincia
  }
}

function configurarTelefono(idpais, codigoTelefonico, pattern, idForm) {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoTelefono = 'form_cupon_cupon_telefono';
  /***/
  /* ********************************************* */
  $(idForm + '#prefTelf').find('.prefijo-box').html(codigoTelefonico);

  if (empty(pattern)) {
    $(idForm + '#' + idCampoTelefono).removeAttr('pattern');
  } else {
    $(idForm + '#' + idCampoTelefono).attr('pattern', pattern);
  }

  if (idpais == 90 || idpais == 'ES') {

    maxlengthTelefono = 9;
    minlengthTelefono = 9;

    $(idForm + '#' + idCampoTelefono).attr('maxlength', maxlengthTelefono);
    $(idForm + '#' + idCampoTelefono).attr('minlength', minlengthTelefono);
  } else {
    
    maxlengthTelefono = 25;
    const [min, max] = Array.from(pattern.matchAll(/\d+/g));

    $(idForm + '#' + idCampoTelefono).attr('maxlength', max[0]);
    $(idForm + '#' + idCampoTelefono).attr('minlength', min[0]);
  }

  $(idForm + '#form_cupon_prefijo').val(codigoTelefonico);
}

function setForwardUrl(form_id, iframe) {
  var baseUrl = rutaweb + rutajs;
  var idEstudio = $("#" + form_id + " #form_cupon_idcurso").val();
  var telefono = $("#" + form_id + " #form_cupon_cupon_telefono").val();
  var nombre = $("#" + form_id + " #form_cupon_cupon_nombre").val();  
  var transaction_id = $(
    "#" + form_id + " #form_cupon_cupon_transaction_id"
  ).val();
  var adsid = $("#" + form_id + " #form_cupon_cupon_adsid").val();
  iframe = iframe === undefined ? "" : "&iframe=on";

  if (compruebaTelefonoCaracteres(form_id, "form_cupon_cupon_telefono"))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $("#btnInformacion").attr("disabled", true);
  $("#btnInformacion").html(htmlSpinner);

  if (typeof rutamainjs === "undefined") baseUrl = rutaweb + rutajs;
  else baseUrl = rutaweb + rutamainjs;

  $("#" + form_id + " #forward_url").val(
    baseUrl +
      "gracias?codigoCurso=" +
      idEstudio +
      "&telefono=" +
      telefono +
      "&nombre=" +
      nombre +
      "&transaction_id=" +
      transaction_id +
      "&adsid=" +
      adsid +
      iframe
  );
  enviarEventoFormulario();
  return true;
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $("#" + form_id + " #" + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $("#" + form_id + " #" + telefono).val("");
  inputTelefono.reportValidity();

  return true;
}

function enviarEvento() {
  var valorCategoria = $("#CategoriaCuponGeneral option:selected").html();
  var valorCurso = $("#form_cupon_idcurso option:selected").html();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_send",
    step: "1",
    formacion: "curso",
    categoria: valorCategoria, // Aquí la categoría de la elección anterior.
    curso: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  });

  enviarEventoFormulario(2);
}

function enviarEventoFormulario(){
  var valorTipo = $('#tipoCuponGeneral option:selected').html(); // Este valor está en el cupón del modal
  if (typeof valorTipo === 'undefined'){ // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorTipo = $('#form_cupon_tipo_curso').val();
    if (typeof valorTipo === 'undefined'){ // Si estoy en un centro lo cojo del select del curso
      var valorTipo = $('#form_cupon_idcurso option:selected').attr("data-formacion");
    }
  }
  if (valorTipo == '-- Oposiciones --')
    valorTipo = 'oposicion';
  else if (valorTipo == '-- Cursos --' || valorTipo == '-- FP --')
    valorTipo = 'curso';

  var valorCategoria = $('#CategoriaCuponGeneral option:selected').html(); // Este valor está en el cupón del modal
  if (typeof valorCategoria === 'undefined'){ // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCategoria = $('#form_cupon_categoria').val();
    if (typeof valorCategoria === 'undefined'){ // Si estoy en un centro lo cojo del select del curso
      var valorCategoria = $('#form_cupon_idcurso option:selected').attr("data-categoria");
    }
  }
  var valorCurso = $('#form_cupon_idcurso option:selected').html();
  if (typeof valorCurso === 'undefined'){ // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCurso = $('#form_cupon_nombre_curso').val();
  }
  var valorPais = $('#paisid option:selected').html();
  if (valorPais == '-- Pais --')
    valorPais = '';
  var valorProvincia = $('#provinciaid option:selected').html();
  if(valorProvincia == '-- Provincia --' || valorProvincia == '-- Estado --')
    valorProvincia = '';
  var valorCP = $('#form_cupon_cupon_codigopostal').val();
  var valorNacionalidad = $('#nacionalidad option:selected').html();
  if (valorNacionalidad == '-- Nacionalidad --')
    valorNacionalidad = '';
  var valorEdad = $('#edad option:selected').html();
  if (valorEdad == '-- Edad --')
    valorEdad = '';
  var valorEstudios = $('#estudiosid option:selected').html();
  if (valorEstudios == '-- Nivel de estudios --')
    valorEstudios = '';  

  window.dataLayer = window.dataLayer|| [];
  window.dataLayer.push({
  'event': 'form_send',
  'step': '2',
  'formacion': valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
  'categoria': valorCategoria, // Aquí la categoría de la elección anterior. 
  'curso': valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  'pais': valorPais, // Queremos saber de qué país es.
  'provincia': valorProvincia, // Queremos saber de qué provincia es.
  'cp': valorCP, // Queremos saber el código postal.
  'nacionalidad': valorNacionalidad, // Queremos saber de qué nacionalidad es.
  'edad': valorEdad, // Queremos saber la edad escogida. 
  'nivel_estudios': valorEstudios // Queremos el nivel de estudios que ha indicado 
  });
}

function getComboMD(tipo, required, padre, Null,idForm) {
  if (typeof idForm === "undefined") idForm = "";
  jQuery.ajax({
    type: "POST",
    async: false,
    url: rutajs + "lib/ajax.php",
    data:
      "fn=getComboMD&tipo=" +
      tipo +
      "&required=" +
      required +
      "&padre=" +
      padre +
      "&idioma_cupon=" +
      idioma_cupon,
    success: function (data) {
      jQuery(idForm + "#cont-" + tipo).html(data);
      jQuery(idForm + "#" + tipo + "id").html(data);

      if (tipo == "pais") {
        jQuery(idForm + "#cont-" + tipo + " select").attr(
          "onchange",
          "chkPais($(this).val(), ,"+idForm+")"
        );
        jQuery(
          idForm +
            "#cont-" +
            tipo +
            ' select option[value="' +
            idpais +
            '"]:first'
        ).prop("selected", true);
        configurarCamposCupon(idpais, idForm);
        configurarTelefono(idpais, prefijotelefonico, patterntelefonico, idForm);

      }
    },
  });
}

function restringirCampoNumerico(idCampo) {
  $("#" + idCampo).on("input", function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, "")
        );
      }
    });
  });
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
    $(spinnerContenedor).appendTo(elementoContenedor);
    $(".spinner-contenedor").html(htmlSpinner);
  } else {
    $(".spinner-contenedor").remove();
  }
}

function getInfoCurso(codCurso) {
  if (codCurso != '') {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data: 'fn=getInfoCurso&codCurso=' + codCurso,
      dataType: 'json',
      success: function (data) {
        if (data && data.aCurso) {
          $('#form_cupon_codcurso').val(data.aCurso.codCursoReal);
          $('#form_cupon_idcurso').val(data.aCurso.idCursoReal);
          $('#form_cupon_categoria').val(data.aCurso.categoriaNombre);
          $('#form_cupon_nombre_curso').val(data.aCurso.sNombre);
        }
      },
    });
  } else {
    $('#form_cupon_codcurso').val('');
    $('#form_cupon_idcurso').val('');
    $('#form_cupon_categoria').val('');
    $('#form_cupon_nombre_curso').val('');
  }
}

// Nuevo cupón modal
$(document).on('click', '.solicita-informacion', function (e) {
  var esLlamada = $(this).is('#customEnlaceLlamadaFueraHorario');
  var eventoWeb = $(this).data('evento');

  cargaModal(e, null, null, eventoWeb, esLlamada);
});

function cargaModal(e = null, categoria = null, curso = null, eventoWeb = undefined, esLlamada = false) {
  if (e && typeof e.stopPropagation === 'function') {
    e.preventDefault();
    e.stopPropagation();
  }

  if(!empty(categoria))
    catCuponPost = categoria;
  else
    catCuponPost = catCupon;

  if(!empty(curso))
    curCuponPost = curso;
  else
    curCuponPost = curCupon;

  if(eventoWeb == undefined)
    eventoWeb = 'Solicita_info';

  if(!empty(curCuponPost)) {
    mostrarOcultarSpinner(true, '.overlay-modal');

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);
          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");

          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }

          $("#cm-form #datosCupon").html("");

          jQuery.ajax({
            type: "POST",
            async: true,
            url: rutajs + "lib/ajax.php",
            data: 'fn=getCupon&idCursoComercial=' + curCuponPost +
              '&isModal=' +
              '-modal' +
              '&iw=' +
              cdn_idweb +
              '&rcdn=' +
              cdn_rutacdn +
              '&pCupon=' +
              encodeURIComponent(pCupon) +
              '&rw=' +
              cdn_rutaweb +
              '&lang=' +
              idioma_cupon,
            success: function (data) {
              if (data != '') {
                $('#cm-form #datosCupon').append(data);

                $(".slick-form-modal").slick("slickGoTo", 3);
                $(".cm-form-main-wrapper .pasos span").text("2");
                $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
                $("#cm-form").addClass("limit-width");

                if(hideBtnBackModal) {
                  $(".cm-form-main-wrapper .btn-back").hide();
                  $(".cm-form-main-wrapper .button-row").css('display', 'block');
                }

                enviarEvento('formularioCuponGeneral');
              }

              if(typeof loadRecaptchaLibrary === 'function')
                loadRecaptchaLibrary();
            },
          }).done(function(){
            $("#cm-form").addClass("visible");
            mostrarOcultarSpinner(false, '.overlay-modal');

            setTimeout(function () {
              $('.slick-form-modal').slick('setPosition');
            }, 500);
          });
        }
      },
    })
  } else {
    mostrarOcultarSpinner(true, '#cm-form');

    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);

          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");
          $("#cm-form").addClass("visible");

          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });

          $(".back-1").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 0);
            $("#cm-form").removeClass("limit-width");
          });
          $(".btn-back").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
            $(".cm-form-main-wrapper .pasos span").text("1");
            $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("Infórmate gratis y sin compromiso");
            $("#cm-form").removeClass("limit-width");
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }
        }
      },
    }).done(function(){
      if (aCatCupon != '' && aCatCupon != undefined) {
        $('.selector-modal-categoria').closest('li').hide();

        $.each(aCatCupon, function(index, value) {
          $('#categoria-modal-' + value).closest('li').show();
        });
      }

      if (catCuponPost != '' && catCuponPost != undefined)
        $('#categoria-modal-' + catCuponPost).click();
    });
  }
}

function cargaCursos(element) {
  var idCategoria = element.data('categoria-id');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#cm-form');

    $("#stepCurso").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursosGrupo&valorCategoria=" + idCategoria,
      success: function (data) {
        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          var html = '';
          var idCategoria = null;
          var nGrupo = "";
          var style = "";
          var currentGroupHtml = "";

          $.each(data.aCursos, function (index, value) {

            var showCourse = (aCurCupon == '' || aCurCupon == undefined || $.inArray(value.idCursoComercial, aCurCupon) !== -1);
            if (showCourse) {
              if (value.idCategoria != idCategoria) {
                if (idCategoria !== null) {
                  html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idCategoria + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
                }
                idCategoria = value.idCategoria;
                nGrupo = (value.sGrupo != undefined) ? value.sGrupo : value.categoriaNombre;
                currentGroupHtml = '';
              }
              currentGroupHtml += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s tipo-formacion-general tipo-formacion-' + value.idCategoria + '" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')" ' + style + '>' + value.sNombre + '</a></li>';
            }
          });

          if (idCategoria !== null) {
            html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idCategoria + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
          }

          $("#stepCurso").html(html);
          $(".step-categoria-nombre").html(sNombre + '<svg class="i"><use xlink:href="#cm-lapiz"></use></svg>');
          $(".slick-form-modal").slick("slickGoTo", 1);
          $("#cm-form").removeClass("limit-width");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
      setTimeout(function () {
        setTimeout(function () {
          if (curCuponPost != "" && curCuponPost != undefined)
            $('#curso-' + curCuponPost).click();
        }, 1000);
      }, 1000);

      mostrarOcultarSpinner(false, '#cm-form');
    });
  }
}

function cargaCupon(element, isModal = '') {
  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#cm-form');

    $("#cm-form #datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {

        if (data != '') {
          $('#cm-form #datosCupon').append(data);
          $(".slick-form-modal").slick("slickGoTo", 2);
          $(".cm-form-main-wrapper .pasos span").text("2");
          $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
          $("#cm-form").addClass("limit-width");

          if(hideBtnBackModal) {
            $(".cm-form-main-wrapper .btn-back").hide();
            $(".cm-form-main-wrapper .button-row").css('display', 'block');
          }

          enviarEvento('formularioCuponGeneral');
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#cm-form');
    });
  }
}

function datosCurso() {
  var valorCurso = $('#form_cupon_idcurso option:selected').html();
  var nameCategoria = $('#form_cupon_idcurso option:selected').data('categoria');

  $('#form_cupon_categoria').val(nameCategoria);
  $('#form_cupon_curso').val(valorCurso);
}